import React, { forwardRef } from "react";
import { fileUrl, SCHOOL_LOGO } from "@/lib/api";

const SCHOOL_NAME = "SLB PELITA NUSA";
const YAYASAN = "Yayasan Bintang Pelita Nusa";
const ALAMAT_SEKOLAH = "Jalan Kaharuddin Nasution Nomor 178 Pekanbaru";
const TELP_WEB = "Telp. (0761) 7876 083  Website : www.slbpelitanusa.sch.id";
const KEPSEK_NAMA = "ADHEESTYA INDAH LESTARI, S.PSI., GR";
const CAP_SEKOLAH = "https://customer-assets.emergentagent.com/job_school-connect-281/artifacts/eec0u94f_cap%20sekolah.png";
const TANDATANGAN_KEPSEK = "https://customer-assets.emergentagent.com/job_school-connect-281/artifacts/1blr37sr_tandatangan%20kepsek%20kecil.png";

const MONTHS_ID = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

function formatTanggalLahir(tempat, tanggal) {
  if (!tanggal) return tempat || "—";
  const [y, m, d] = tanggal.split("-");
  const bulan = MONTHS_ID[parseInt(m, 10) - 1] || m;
  return `${tempat || "—"}, ${parseInt(d, 10)} ${bulan} ${y}`;
}

const CARD_W = 540;
const CARD_H = 340;

// FRONT side of Kartu Pelajar
export const KartuPelajarFront = forwardRef(function KartuPelajarFront({ siswa }, ref) {
  return (
    <div
      ref={ref}
      style={{
        width: CARD_W, height: CARD_H,
        background: "#f3f4f6",
        position: "relative",
        fontFamily: "Arial, sans-serif",
        overflow: "hidden",
        borderRadius: 12,
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
      }}
      data-testid="kartu-pelajar-front"
    >
      {/* Green decorative shapes — header lebih tipis */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 100, background: "linear-gradient(135deg, #1f7a3a 0%, #2d9a4a 60%, #5dbd6f 100%)", clipPath: "polygon(0 0, 100% 0, 100% 70%, 0 100%)" }} />
      <div style={{ position: "absolute", top: 92, left: 0, right: 0, height: 14, background: "#1f7a3a", clipPath: "polygon(0 0, 100% 0, 95% 100%, 0 60%)" }} />
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 22, background: "linear-gradient(135deg, #1f7a3a 0%, #2d9a4a 60%, #5dbd6f 100%)", clipPath: "polygon(0 30%, 100% 0, 100% 100%, 0 100%)" }} />

      {/* School logo + header */}
      <div style={{ position: "absolute", top: 8, left: 14, width: 60, height: 72, background: "#fff", borderRadius: 8, padding: 5, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>
        <img src={SCHOOL_LOGO} alt="logo" crossOrigin="anonymous" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
      </div>
      <div style={{ position: "absolute", top: 8, left: 84, right: 14, color: "#fff", textAlign: "center" }}>
        <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.5, opacity: 0.95 }}>{YAYASAN}</div>
        <div style={{ fontSize: 19, fontWeight: 800, letterSpacing: 1.3, marginTop: 1 }}>{SCHOOL_NAME}</div>
        <div style={{ fontSize: 8.5, marginTop: 4, opacity: 0.95, lineHeight: 1.35 }}>{ALAMAT_SEKOLAH}</div>
        <div style={{ fontSize: 8.5, opacity: 0.95 }}>{TELP_WEB}</div>
      </div>

      {/* Title KARTU PELAJAR */}
      <div style={{ position: "absolute", top: 116, left: 0, right: 0, textAlign: "center", color: "#1e3a5f", fontSize: 22, fontWeight: 800, letterSpacing: 2 }}>KARTU PELAJAR</div>

      {/* Foto siswa */}
      <div style={{ position: "absolute", top: 155, left: 24, width: 110, height: 140, background: "#dc2626", border: "2px solid #fff", borderRadius: 6, overflow: "hidden", boxShadow: "0 2px 6px rgba(0,0,0,0.2)" }}>
        {siswa?.foto_file_id ? (
          <img src={fileUrl(siswa.foto_file_id) + (fileUrl(siswa.foto_file_id).includes("?") ? "&" : "?") + "kp=1"} alt="foto" crossOrigin="anonymous" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#fca5a5", color: "#7f1d1d", fontSize: 28, fontWeight: 800 }}>{(siswa?.nama || "?")[0]}</div>
        )}
      </div>

      {/* Data siswa */}
      <div style={{ position: "absolute", top: 160, left: 158, right: 20, color: "#1e3a5f", fontSize: 13 }}>
        {[
          ["Nama", siswa?.nama],
          ["NISN", siswa?.nis],
          ["Jenis Kelamin", siswa?.jenis_kelamin === "L" ? "Laki-laki" : "Perempuan"],
          ["T.T.L", formatTanggalLahir(siswa?.tempat_lahir, siswa?.tanggal_lahir)],
          ["Alamat", siswa?.alamat || "—"],
        ].map(([k, v]) => (
          <div key={k} style={{ display: "flex", marginBottom: 4, alignItems: "flex-start" }}>
            <div style={{ width: 92, fontWeight: 500 }}>{k}</div>
            <div style={{ width: 8 }}>:</div>
            <div style={{ flex: 1, fontWeight: 700, lineHeight: 1.25, wordBreak: "break-word" }}>{v || "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
});

// BACK side of Kartu Pelajar
export const KartuPelajarBack = forwardRef(function KartuPelajarBack(_props, ref) {
  return (
    <div
      ref={ref}
      style={{
        width: CARD_W, height: CARD_H,
        background: "#f3f4f6",
        position: "relative",
        fontFamily: "Arial, sans-serif",
        overflow: "hidden",
        borderRadius: 12,
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
      }}
      data-testid="kartu-pelajar-back"
    >
      {/* Green decorations — lebih tipis di atas agar tidak kena kotak KETENTUAN */}
      <div style={{ position: "absolute", top: 0, left: 0, width: "45%", height: 36, background: "linear-gradient(135deg, #1f7a3a 0%, #2d9a4a 60%, #5dbd6f 100%)", clipPath: "polygon(0 0, 90% 0, 100% 100%, 0 100%)" }} />
      <div style={{ position: "absolute", top: 24, right: 0, width: "45%", height: 36, background: "linear-gradient(135deg, #5dbd6f 0%, #2d9a4a 100%)", clipPath: "polygon(15% 0, 100% 0, 100% 100%, 0 100%)", opacity: 0.85 }} />
      <div style={{ position: "absolute", bottom: 0, left: 0, width: "40%", height: 50, background: "linear-gradient(135deg, #1f7a3a 0%, #2d9a4a 60%, #5dbd6f 100%)", clipPath: "polygon(0 0, 100% 50%, 100% 100%, 0 100%)" }} />
      <div style={{ position: "absolute", bottom: 0, right: 0, width: "40%", height: 30, background: "#1f7a3a", clipPath: "polygon(20% 0, 100% 0, 100% 100%, 0 100%)" }} />

      {/* KETENTUAN header — sedikit naik agar jauh dari poin 1, tetap tidak kena border hijau atas */}
      <div style={{ position: "absolute", top: 48, left: 24, padding: "8px 18px", border: "2px solid #1e3a5f", borderRadius: 6, background: "#f3f4f6", zIndex: 5 }}>
        <div style={{ fontSize: 24, fontWeight: 900, color: "#1e3a5f", fontFamily: "'Courier New', monospace", letterSpacing: 2 }}>KETENTUAN</div>
      </div>

      {/* Rules — dinaikkan agar tidak bertabrakan dengan "Kepala SLB" */}
      <ol style={{ position: "absolute", top: 110, left: 28, right: 28, margin: 0, padding: 0, listStyle: "decimal inside", color: "#1e3a5f", fontSize: 10.5, lineHeight: 1.5 }}>
        <li style={{ marginBottom: 4 }}>Pemegang Kartu Pelajar ini sah sebagai siswa SLB Pelita Nusa.</li>
        <li style={{ marginBottom: 4 }}>Kartu Pelajar tidak berlaku bagi siswa yang berhenti atau mengundurkan diri.</li>
        <li style={{ marginBottom: 4 }}>Kartu Pelajar yang hilang/rusak wajib segera dilaporkan kepada Bagian Kesiswaan.</li>
        <li style={{ marginBottom: 4 }}>Penyalahgunaan kartu ini akan ditindak sesuai aturan yang berlaku.</li>
      </ol>

      {/* Signature + Cap — ruang lebih kecil agar "Kepala SLB" turun ke bawah, nama tetap di posisi semula */}
      <div style={{ position: "absolute", bottom: 38, right: 14, textAlign: "center", color: "#1e3a5f", width: 240 }}>
        <div style={{ fontSize: 11, fontStyle: "italic", marginBottom: 1 }}>Kepala SLB Pelita Nusa</div>
        <div style={{ position: "relative", height: 62, marginBottom: 2 }}>
          {/* Cap (stamp) — digeser ke kanan agar pas di tengah bawah "Kepala SLB Pelita Nusa" */}
          <img
            src={CAP_SEKOLAH}
            alt="cap"
            crossOrigin="anonymous"
            style={{ position: "absolute", left: 50, top: 2, width: 60, height: 60, objectFit: "contain", opacity: 0.55, zIndex: 1 }}
          />
          {/* Tandatangan kepsek — start dari kiri, hanya ujung kiri menumpuk cap */}
          <img
            src={TANDATANGAN_KEPSEK}
            alt="tandatangan"
            crossOrigin="anonymous"
            style={{ position: "absolute", left: 68, top: 6, width: 175, height: 52, objectFit: "contain", objectPosition: "left center", zIndex: 2, mixBlendMode: "multiply" }}
          />
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, borderTop: "1px solid #1e3a5f", paddingTop: 3 }}>{KEPSEK_NAMA}</div>
      </div>
    </div>
  );
});
